import { randomId } from "../helpers/general";

export default {
  install: Vue => {
    Vue.mixin({
      methods: {
        createToggleButton({
          checked = false,
          callback = null,
          toggleStyle = "",
          dotStyle = ""
        }) {
          bindToggles(this);
          const toggle = { id: randomId(12), checked, callback };
          this._toggles.push(toggle);

          toggleStyle += `
            width: 44px;
            height: 24px; 
            background-color: ${backgroundColor(checked)};
          `;

          dotStyle += `
            background: white; 
            width: 20px; 
            height: 20px; 
            min-width: 20px; 
            min-height: 20px; 
            margin-left: ${marginLeft(checked)};`;

          return `
          <span id="${toggle.id}" class="toggle-button" style="${toggleStyle}">
            <span aria-hidden="true" class="dot" style="${dotStyle}">
            </span>
          </span>`;
        },
        hookToggleButtons() {
          bindToggles(this);

          setTimeout(() => {
            let i = this._toggles.length;
            while (i--) {
              const toggle = this._toggles[i];
              const el = document.getElementById(toggle.id);
              if (el) {
                if (!toggle.handler) {
                  toggle.handler = function() {
                    handleClick(toggle);
                  };
                  el.addEventListener("click", toggle.handler);
                }
              } else {
                this._toggles.splice(i, 1);
              }
            }
          });
        }
      }
    });
  }
};

const colorEnabled = "#34C759";
const colorDisabled = "#CCC";

const backgroundColor = checked => {
  return `${checked ? colorEnabled : colorDisabled}`;
};

const marginLeft = checked => {
  return `${checked ? "21px" : "3px"}`;
};

const bindToggles = v => {
  if (!v._toggles) {
    v._toggles = [];
  }
};

const handleClick = toggle => {
  const trigger = () => {
    toggle.checked = !toggle.checked;

    const el = document.getElementById(toggle.id);
    const dot = el.querySelector(".dot");
    el.style.backgroundColor = backgroundColor(toggle.checked);
    dot.style.marginLeft = marginLeft(toggle.checked);

    if (toggle.callback) {
      toggle.callback(toggle.checked);
    }
  };

  if (!toggle.timestamp) {
    toggle.timestamp = Date.now();
    trigger();
    return;
  }

  const threshold = Date.now() - toggle.timestamp;
  if (threshold >= 200) {
    toggle.timestamp = 0;
    trigger();
  }
};
